<div class="card h-100">
  <div
    class="card-body d-flex"
    data-testid="enter-course"
    (click)="course.is_activated ? onRoute() : null"
    style="cursor: pointer"
  >
    <div class="d-flex flex-column w-100 h-100">
      <!-- Image -->
      <div class="col-sm-12 mb-0 cursor-pointer">
        <img
          [src]="
            course.course_image_url
              ? fileUrl + course.course_image_url
              : './assets/media/svg/files/blank-image.svg'
          "
          class="course-thumb rounded-nested bg-light"
          [attr.alt]="course.course_name"
        />
      </div>
      <!-------->
      <div
        class="col-sm-12 d-flex flex-column justify-content-between flex-grow-1 pt-8"
      >
        <p
          class="text-gray-800 text-hover-primary min-h-30px fs-3 fw-bold lh-1 mb-2 cursor-pointer text-overflow-line-2"
        >
          {{ course.course_name }}
        </p>
        @if (course.is_trial) {
        <span class="badge badge-light-warning mb-2" data-testid="trial-badge">
          {{ "APP.TRIAL_BADGE" | translate }}
        </span>
        }
        @if (course.is_activated === false) {
        <div #button_group class="col-12 border-top pt-4">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap d-grid gap-2"
          >
            <div class="d-flex align-items-center w-100 gap-2">
              @if (course.is_activated === false) {
              <button class="btn w-100 btn-primary" data-testid="activate-course" (click)="onActivate()">
                {{ "ONLINE_CLASS.ACTIVATE_COURSE" | translate }}
              </button>
              }
            </div>
          </div>
        </div>
        } @else {
        <div class="col-12 border-top pt-6">
          <!-- The label and the number on one line. The percentage was rendered
               into an empty span and only existed in a tooltip, so the bar was
               a shape with no value — you could see roughly how far along you
               were and never how far. -->
          <div class="d-flex align-items-baseline justify-content-between">
            <span class="fs-7 text-muted">{{ "ONLINE_CLASS.PROGRESS" | translate }}</span>
            <span class="course-progress__value">{{ (course.progress || 0) | number:'1.0-0' }}%</span>
          </div>
          <div class="mt-2 w-100">
            <div class="d-flex align-items-center w-100">
              <!-- Brand, not green. Green is this palette's "passed"; a bar that
                   is green at 4% says the wrong thing about a course you have
                   barely started. -->
              <div
                class="progress course-progress w-100"
                [ngbTooltip]="`ความคืบหน้า: `+ ((course.progress||0) | number:'1.2-2' ) + `%`"
              >
                <div
                  class="progress-bar course-progress__bar"
                  role="progressbar"
                  [style.width.%]="course.progress"
                  [attr.aria-valuenow]="course.progress"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
          </div>
          <section class="fs-6 mt-4 text-gray-800">
            <div class="d-flex justify-content-between align-items-center mt-2">
              <div class="fs-7">
                {{ "ONLINE_CLASS.DURATION_TIME" | translate }}
              </div>
              <div>{{ course.expire_duration_video | durationVideo }}</div>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-2">
              <div class="fs-7">
                {{ "ONLINE_CLASS.SPENT_TIME" | translate }}
              </div>
              <!-- `fullTime`, so a short session reads as "8ว." rather than
                   rounding down to "0น." and claiming nothing was watched. -->
              <div>{{ course.duration_spent | durationVideo : "fullTime" }}</div>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-2">
              <div class="fs-7">
                {{ "ONLINE_CLASS.EXPIRE_DATE" | translate }}
              </div>
              <div>
                {{
                  course.expire_date
                    ? (course.expire_date | customDate)
                    : ("ONLINE_CLASS.NO_EXPIRE" | translate)
                }}
              </div>
            </div>
          </section>
        </div>
        }
      </div>
    </div>
  </div>
</div>
